"use client";

import { RichText } from "@/components/RichText/RichText.component";
import { checkIfImage, cn } from "@/lib/utils";
import Image from "next/image";
import { Typography } from "../Typography/Typography.component";
import VideoModule from "../VideoModule/VideoModule.component";
import { HeroVideoShowcasePropsModel } from "./HeroVideoShowcase.model";

const HeroVideoShowcase = ({
  name,
  title = "WE DO BIG THINGS",
  content,
  asset,
}: HeroVideoShowcasePropsModel) => {
  console.log(content);

  // Replace "/" with line breaks for title formatting
  const formatTitle = (titleText: string) => {
    return titleText.replace(/\//g, "\n");
  };

  return (
    <div className="bg-core-red relative min-h-[810px] w-full overflow-hidden md:h-screen">
      {/* Video/Background Image Container */}
      <div
        className={cn(
          "absolute overflow-hidden",
          // Mobile: Full screen positioned at the top
          "inset-x-4 top-16 h-[243px] rounded-2xl",
          // Desktop: Centered in the upper portion
          "lg:inset-x-auto lg:top-[8vw] lg:bottom-[416px] lg:left-1/2 lg:h-[24vw] lg:w-[40vw] lg:-translate-x-1/2",
        )}
      >
        {asset && !checkIfImage(asset?.contentType) && (
          <VideoModule
            name={name || "Hero Video"}
            video={asset}
            showVideoControls={false}
          />
        )}
        {asset && checkIfImage(asset?.contentType) && (
          <Image
            src={asset.url}
            alt={asset.title || "Hero image"}
            className="h-full w-full object-cover"
          />
        )}
      </div>

      {/* Main Title */}
      <div
        className={cn(
          "absolute left-4",
          // Mobile: Centered vertically in lower portion
          "top-[370px] -translate-y-1/2",
          // Desktop: Positioned absolutely
          "lg:top-[411.5px]",
        )}
      >
        <Typography.Display
          color="core-white"
          className={cn(
            "!leading-[0.8] !font-semibold whitespace-pre-line uppercase",
            "text-[80px] tracking-[-2px]",
            // Desktop sizing
            "lg:text-[224px] lg:tracking-[-4.48px]",
          )}
        >
          {formatTitle(title)}
        </Typography.Display>
      </div>

      {/* Body Text */}
      {content && (
        <div
          className={cn(
            "absolute left-4",
            // Mobile: Bottom positioned with full content width
            "top-[654px] w-[50%] -translate-y-1/2",
            // Desktop: Right-aligned with different positioning
            "lg:top-[585px] lg:left-[calc(75%-30px)] lg:w-[200px]",
          )}
        >
          <RichText
            content={content.json}
            additionalClassName={{
              paragraph: "text-core-white leading-[1.2] mb-0",
              heading: "text-core-white",
              link: "text-core-white underline",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default HeroVideoShowcase;
